var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { attr } from '@ember-data/model';
import { array, fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
import { CatalogVisibility } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogVisibility as CatalogVisibilityProto, CatalogItemProductType as CatalogItemProductTypeProto, EcomVisibility as EcomVisibilityProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
export let EcomVisibility = /*#__PURE__*/function (EcomVisibility) {
  EcomVisibility["DO_NOT_USE"] = "DO_NOT_USE";
  EcomVisibility["UNINDEXED"] = "UNINDEXED";
  EcomVisibility["UNAVAILABLE"] = "UNAVAILABLE";
  EcomVisibility["HIDDEN"] = "HIDDEN";
  EcomVisibility["VISIBLE"] = "VISIBLE";
  return EcomVisibility;
}({});
let Data = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('boolean', {
  allowNull: true
}), _dec6 = attr('string', {
  protoEnum: CatalogVisibilityProto,
  defaultValue: CatalogVisibility.PRIVATE
}), _dec7 = attr('boolean', {
  allowNull: true
}), _dec8 = attr('boolean', {
  allowNull: true
}), _dec9 = attr('boolean', {
  allowNull: true
}), _dec10 = attr('string'), _dec11 = attr('string'), _dec12 = attr('number'), _dec13 = fragmentArray('connect/item/modifier-list-info'), _dec14 = attr('string'), _dec15 = attr('string', {
  protoEnum: CatalogItemProductTypeProto
}), _dec16 = attr('boolean', {
  allowNull: true,
  defaultValue: false
}), _dec17 = array(), _dec18 = attr('string'), _dec19 = array(), _dec20 = attr('boolean', {
  allowNull: true
}), _dec21 = attr('string'), _dec22 = attr('string'), _dec23 = attr('string', {
  protoEnum: EcomVisibilityProto
}), _dec24 = array(), _dec25 = array(), _dec26 = attr('string'), _dec27 = fragmentArray('connect/category/membership'), _dec28 = fragment('connect/category/membership'), _dec29 = fragment('connect/ecom-seo-data'), _dec30 = fragment('connect/open-graph-data'), _dec31 = attr('string'), _dec32 = attr('string'), _dec33 = attr('string'), _dec34 = attr('string'), _dec35 = attr('string'), _dec36 = attr('string'), _dec37 = attr('string'), _dec38 = array(), _dec39 = attr('boolean', {
  allowNull: true
}), _dec40 = attr('number', {
  allowNull: true
}), _dec41 = attr('boolean', {
  allowNull: true,
  defaultValue: false
}), _dec42 = attr('string'), _dec43 = attr('boolean', {
  allowNull: true
}), _dec44 = attr('string', {
  allowNull: true
}), _dec45 = fragment('connect/item/food-and-beverage-details'), _dec46 = fragment('connect/item/combo-type-details'), (_class = (_class2 = class Data extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "description", _descriptor2, this);
    _initializerDefineProperty(this, "abbreviation", _descriptor3, this);
    _initializerDefineProperty(this, "labelColor", _descriptor4, this);
    _initializerDefineProperty(this, "isTaxable", _descriptor5, this);
    _initializerDefineProperty(this, "visibility", _descriptor6, this);
    _initializerDefineProperty(this, "availableOnline", _descriptor7, this);
    _initializerDefineProperty(this, "availableForPickup", _descriptor8, this);
    _initializerDefineProperty(this, "availableElectronically", _descriptor9, this);
    _initializerDefineProperty(this, "categoryId", _descriptor10, this);
    _initializerDefineProperty(this, "buyerFacingName", _descriptor11, this);
    _initializerDefineProperty(this, "ordinal", _descriptor12, this);
    _initializerDefineProperty(this, "modifierListInfo", _descriptor13, this);
    _initializerDefineProperty(this, "imageUrl", _descriptor14, this);
    _initializerDefineProperty(this, "productType", _descriptor15, this);
    _initializerDefineProperty(this, "skipModifierScreen", _descriptor16, this);
    _initializerDefineProperty(this, "itemOptions", _descriptor17, this);
    _initializerDefineProperty(this, "ecomUri", _descriptor18, this);
    _initializerDefineProperty(this, "ecomImageUris", _descriptor19, this);
    _initializerDefineProperty(this, "ecomAvailable", _descriptor20, this);
    _initializerDefineProperty(this, "onlineStoreData", _descriptor21, this);
    _initializerDefineProperty(this, "ecomBuyButtonText", _descriptor22, this);
    _initializerDefineProperty(this, "ecomVisibility", _descriptor23, this);
    _initializerDefineProperty(this, "imageIds", _descriptor24, this);
    _initializerDefineProperty(this, "legacyTaxIds", _descriptor25, this);
    _initializerDefineProperty(this, "sortName", _descriptor26, this);
    _initializerDefineProperty(this, "categories", _descriptor27, this);
    /* @fragment('connect/category/membership')
    declare category?: CategoryMembership; */
    _initializerDefineProperty(this, "reportingCategory", _descriptor28, this);
    _initializerDefineProperty(this, "ecomSeoData", _descriptor29, this);
    _initializerDefineProperty(this, "openGraphData", _descriptor30, this);
    // -----------------------------------------------
    // These ids are in the process of being deprecated for SQ Items, and should not be used to look up Fulfillment Preferences.
    // Call the FP API using the item id instead.
    _initializerDefineProperty(this, "shippingFulfillmentPreferencesId", _descriptor31, this);
    _initializerDefineProperty(this, "pickupFulfillmentPreferencesId", _descriptor32, this);
    _initializerDefineProperty(this, "deliveryFulfillmentPreferencesId", _descriptor33, this);
    _initializerDefineProperty(this, "dineInFulfillmentPreferencesId", _descriptor34, this);
    // -----------------------------------------------
    _initializerDefineProperty(this, "descriptionHtml", _descriptor35, this);
    _initializerDefineProperty(this, "descriptionPlaintext", _descriptor36, this);
    _initializerDefineProperty(this, "kitchenName", _descriptor37, this);
    _initializerDefineProperty(this, "channels", _descriptor38, this);
    _initializerDefineProperty(this, "ecomAllowOrderItemQuantities", _descriptor39, this);
    _initializerDefineProperty(this, "ecomOrderItemMaxQuantity", _descriptor40, this);
    _initializerDefineProperty(this, "isArchived", _descriptor41, this);
    _initializerDefineProperty(this, "ageRestrictionId", _descriptor42, this);
    _initializerDefineProperty(this, "requiresSubscriptionToSell", _descriptor43, this);
    _initializerDefineProperty(this, "customShippingBoxId", _descriptor44, this);
    _initializerDefineProperty(this, "foodAndBeverageDetails", _descriptor45, this);
    _initializerDefineProperty(this, "comboTypeDetails", _descriptor46, this);
  }
  get isAvailableOnline() {
    switch (this.ecomVisibility) {
      case EcomVisibility.UNINDEXED:
      case EcomVisibility.UNAVAILABLE:
        return false;
      case EcomVisibility.HIDDEN:
      case EcomVisibility.VISIBLE:
        return true;
      default:
        return Boolean(this.ecomAvailable);
    }
  }
  set isAvailableOnline(value) {
    this.ecomAvailable = value;
    if (value) {
      if (this.ecomVisibility !== EcomVisibility.VISIBLE) {
        this.ecomVisibility = EcomVisibility.HIDDEN;
      }
    } else {
      this.ecomVisibility = EcomVisibility.UNAVAILABLE;
    }
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/item/data'), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "abbreviation", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "labelColor", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isTaxable", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "visibility", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "availableOnline", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "availableForPickup", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "availableElectronically", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "categoryId", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "buyerFacingName", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "modifierListInfo", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "imageUrl", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "productType", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "skipModifierScreen", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "itemOptions", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "ecomUri", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "ecomImageUris", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "ecomAvailable", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "onlineStoreData", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "ecomBuyButtonText", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "ecomVisibility", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "imageIds", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "legacyTaxIds", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "sortName", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "categories", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "reportingCategory", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "ecomSeoData", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "openGraphData", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "shippingFulfillmentPreferencesId", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "pickupFulfillmentPreferencesId", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "deliveryFulfillmentPreferencesId", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "dineInFulfillmentPreferencesId", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "descriptionHtml", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "descriptionPlaintext", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "kitchenName", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "channels", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "ecomAllowOrderItemQuantities", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "ecomOrderItemMaxQuantity", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "isArchived", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "ageRestrictionId", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "requiresSubscriptionToSell", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "customShippingBoxId", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "foodAndBeverageDetails", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "comboTypeDetails", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { Data as default };